import { Link } from 'react-router-dom';
import { articles } from '@/mocks/homeData';

const articleImages = [
  'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20film%20set%20with%20actors%20in%20traditional%20costumes%2C%20warm%20golden%20set%20lighting%2C%20behind%20the%20scenes%20cinematic%20atmosphere%2C%20soft%20amber%20tones%2C%20professional%20film%20production%20scene%2C%20clean%20editorial%20photography%20style&width=800&height=500&seq=article-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Modern%20award%20ceremony%20stage%20with%20golden%20trophy%20on%20pedestal%2C%20warm%20elegant%20lighting%20in%20amber%20and%20cream%20tones%2C%20celebratory%20atmosphere%2C%20clean%20corporate%20event%20photography%20style%2C%20sophisticated%20and%20prestigious%20mood&width=800&height=500&seq=article-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Chinese%20New%20Year%20festive%20cinema%20entrance%20with%20red%20lanterns%20and%20movie%20posters%2C%20warm%20celebratory%20atmosphere%2C%20golden%20and%20coral%20decorations%2C%20people%20excited%20entering%20theater%2C%20clean%20lifestyle%20photography%20with%20festive%20mood&width=800&height=500&seq=article-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20colorful%20video%20app%20interface%20on%20clean%20minimal%20desk%2C%20warm%20natural%20light%20from%20window%2C%20soft%20cream%20background%2C%20tech%20lifestyle%20photography%2C%20clean%20product%20shot%20with%20plant%20and%20coffee%20cup&width=800&height=500&seq=article-04&orientation=landscape',
];

export default function ArticlesSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              最新资讯
            </h2>
            <p className="text-sm text-foreground-500 mt-1">了解豆花视频最新动态与影视资讯</p>
          </div>
          <Link
            to="/articles"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            更多资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={articleImages[article.id - 1]}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={`豆花视频 - ${article.title}`}
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium rounded bg-secondary-100 text-secondary-700">
                  {article.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 mb-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.readCount}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/articles"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap cursor-pointer"
          >
            更多资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}